import React, {PureComponent} from 'react';
import Progress from 'app/components/promo_action/compendium/progress';
import I18n from 'app/i18n';
import {Link} from 'react-router-dom';
import {getPromoLinkPath} from 'app/utils';
import ClickableTooltip from 'app/components/reusable/ClickableTooltip';
import {goToMyHero} from 'app/utils/app_links';
import ConvertButton from 'app/components/my_profile/artifacts/artifact_popup/compendium/ConvertButton';
import SpriteIcon from 'app//utils/sprites/SpriteIcon';

export default class WithoutUserComponent extends PureComponent {
    render() {
        return <div className="compendium-aside__content compendium-aside__content_left">
            <Progress
                {...this.props}
                styleTop={0}
            />
            <div className="compendium-aside__links">
                <div className="compendium-aside__link">
                    <SpriteIcon name="#svg-predictions" size={{height: 16, width: 16}}/>
                    <Link to={getPromoLinkPath('/predictions')}>
                        {I18n.t('compendium.compendium_table')} ({this.props.predictions_total})
                    </Link>
                </div>
                <div className="compendium-aside__link">
                    <SpriteIcon name="#svg-table-leaders" size={{height: 16, width: 16}}/>
                    <Link to={getPromoLinkPath('/rating')}>
                        {I18n.t('compendium.results_table')}
                    </Link>
                </div>
                <div className="compendium-aside__link">
                    <SpriteIcon name="#svg-scatter" size={{height: 16, width: 16}}/>
                    <ConvertButton onClickHandler={goToMyHero} classes={['compendium-aside__scatter-btn']}/>
                    <ClickableTooltip text={this.props.scatterText}/>
                </div>
            </div>
        </div>;
    }
}
